<template>
  <div class="gaoDeMap" ref="gaoDeMap" />
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  name: "gaoDeMap",
  props: {
    zoom: {
      type: Number,
      default: 12,
    },
    center: {
      type: Array,
      default: () => [119.649506, 29.089524],
    },
  },
  data() {
    return {
      map: null,
      AMap: null,
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      const { zoom, center } = this;

      AMapLoader.load({
        key: "9f5c5afddb467e683ecb1602c96e889e",
        version: "2.0",
        plugins: ["AMap.Geocoder"],
      })
        .then((AMap) => {
          this.AMap = AMap;
          this.map = new AMap.Map(this.$refs.gaoDeMap, {
            zoom,
            center,
          });
          this.addMarker();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    addMarker() {
      this.$emit("addMarker", { AMap: this.AMap, map: this.map });
    },
  },
  unmounted() {
    this.map?.destroy();
  },
};
</script>

<style lang="scss" scoped>
.gaoDeMap {
  @include inheritWH;
}
</style>
